import Service from '@/services/Service'

class DeliveryFeeService extends Service {
  constructor() {
    super('DELIVERYFEE')
    this.resource = 'region'
  }

  translateToFirebird(obj) {
    let objFirebird = {
      SEQUENCIAL: obj.codigo,
      DESCRICAO: obj.descricao,
      DISTANCIA: obj.distancia,
      VALOR: obj.valor,
      VALORMINIMOCOMPRA: obj.valorMinimoCompra,
      TEMPOMINUTOS: obj.tempoMinutos,
      ISEXTERIOR: obj.isExterior ? 'S' : 'N',
    }

    return objFirebird
  }

  translateFromFirebird(obj) {
    let objFirebird = {
      codigo: obj.SEQUENCIAL,
      descricao: obj.DESCRICAO,
      distancia: obj.DISTANCIA,
      valor: obj.VALOR,
      valorMinimoCompra: obj.VALORMINIMOCOMPRA,
      tempoMinutos: obj.TEMPOMINUTOS,
      isExterior: obj.ISEXTERIOR == 'S',
      qualquerDistancia: parseInt(obj.DISTANCIA) == -1 || false,
    }

    return objFirebird
  }

  async getDeliveryFee(id) {
    let requestUrl = `${this.resource}/${encodeURIComponent(id)}`
    const response = await this.getAPI(requestUrl)
    return this.translateFromFirebird(response)
  }

  async getDeliveryFees(query = null) {
    if (query) {
      let requestUrl = `${this.resource}?`

      query = this.encodeQueryValues(query)

      if (query.codigo && query.codigo.length > 0) {
        requestUrl += this.hasParameter(requestUrl)
          ? `&CODIGO=${query.codigo}`
          : `CODIGO=${query.codigo}`
      } else if (query.descricao && query.descricao.length > 0) {
        requestUrl += this.hasParameter(requestUrl)
          ? `&DESCRICAO=${query.descricao}`
          : `DESCRICAO=${query.descricao}`
      }

      if (query.todos)
        requestUrl += this.hasParameter(requestUrl)
          ? `&TODOS=${query.todos}`
          : `TODOS=${query.todos}`
      else
        requestUrl += this.hasParameter(requestUrl)
          ? `&page=${query.page}`
          : `page=${query.page}`

      return await this.getAPI(requestUrl)
    } else {
      return Promise.reject('Ocorreu um erro')
    }
  }
}

export default new DeliveryFeeService()
